<form class="flex flex-col flex-grow" [formGroup]="formGroup()" (ngSubmit)="onSubmitPress()">
  <ng-content/>
  <p-button styleClass="w-full" [ngClass]="{
    'mt-auto': !noButtonPadding(),
  }" type="submit"
            [loading]="state() === 'loading'"
            [disabled]="this.formGroup().invalid"
  >
    {{submitButtonLabel()}}
  </p-button>
</form>
